<template>

    <m-edit1/>

    <m-charge-wallet-1 v-bind='{...{"walletId":null},...{}}' :style='""' class="" ></m-charge-wallet-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mChargeWallet1 from '@moeinmdn/miw-alpha-components/src/package/Wallet/ChargeWallet/ChargeWallet1';

export default {
    name: 'HomeView',
    components: {mEdit1, mChargeWallet1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
